import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router";
import Pagination from "../../shared/common/pagination";
import Loader from "../../shared/loader/loader";
import DeleteModal from "../../shared/common/deleteModal";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import { connect } from "react-redux";
import Constant from "../../../utils/constant";
import MultiSelectList from "../questions/metadataDropDownList";
import {
  AddIcon,
  EditIcon,
  DeleteIcon,
  FilterIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  ApproveIcon,
  Disapprove,
  CSVIcon,
} from "../../../assets/icons/index";
import {
  getSkillSubjectAll,
  getSkillSubjectExport,
  deleteSkillSubjectAPI,
} from "../../../api/skill.service";
import ExportToCSV from "../../shared/common/exportToCsv";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiStateButton from "../../shared/common/multiStateButton";

const activeMultiState = [
  { label: "Active", value: true },
  { label: "Both", value: null, selected: true },
  { label: "Inactive", value: false },
];

const PracticeSubjects: React.FC = (props: any) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [newSkills, setNewSkills] = useState<any>([]);
  const [deleteSubjectSkill, setDeleteSkill] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalPages, setTotalPages] = useState(0);
  const [newGrade, setNewGrade] = useState<any>([]);
  const [newContent, setNewContent] = useState<any>([]);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [newBackUpSubjects, setNewBackUpSubjects] = useState<any>([]);
  const [content, setContent] = useState<any>([]);
  const [newStateId, setNewStateId] = useState<number>(0);
  const [newGradeId, setNewGradeId] = useState<number>(0);
  const [newcontentAreaId, setcontentAreaId] = useState<number>(0);
  const [SortDir, setSortDir] = useState<boolean>(true);
  const [selectSubjectname, setSelectSubjectname] = useState("");
  const [selectSubjectId, setSelectSkillSubjectId] = useState<string>("");
  const [sortCol, setSortCol] = useState<string>("name");
  const [isApproved, setisApproved] = useState<boolean>(true);
  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);
  const [dropdownSelectedContentData, setdropdownSelectedContentData] =
    useState<number>(0);
  const navigate = useNavigate();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const childRef: any = useRef(undefined);

  const deleteSkillHandler = (e, skillSubjectId) => {
    e.preventDefault();
    setShowDeleteModal(true);
    const deleteGrade = newSkills.find(
      (skill) => skill.skillSubjectId === skillSubjectId
    );
    setDeleteSkill(deleteGrade);
  };

  const deleteRecordHandler = async () => {
    if (deleteSubjectSkill.skillSubjectId) {
      await deleteSkillSubjectAPI(deleteSubjectSkill.skillSubjectId);
      bindSubjects();
    }
    setShowDeleteModal(false);
  };

  const handleRedirect = (skills: any) => {
    const contentDataToPass = newContent.map((_g) => {
      return {
        label: _g.label,
        value: parseInt(_g.value),
      };
    });

    let dropdownSelectedContentData = {};
    const editSkills = newSkills.find(
      (skill) => skill.skillSubjectId === skills.skillSubjectId
    );

    dropdownSelectedContentData = {
      label: editSkills?.contentAreaName,
      value: editSkills?.contentAreaId,
    };

    navigate(
      Constant.MANAGESKILLSUBJECT.replace(
        ":id",
        skills.skillSubjectId.toString()
      ),
      {
        state: {
          objectToEdit: skills,
          contentData: contentDataToPass,
          selectContentData: dropdownSelectedContentData,
        },
      }
    );
  };

  const handlePostRedirect = () => {
    const contentDataToPass = newContent.map((_g) => {
      return {
        label: _g.label,
        value: parseInt(_g.value),
      };
    });

    navigate(Constant.ADDSKILLSUBJECT, {
      state: {
        objectToEdit: null,
        contentData: contentDataToPass,
      },
    });
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const getGradeData = async () => {
    const service = await import("../../../api/subject.service");
    const response = service.getGradeAll(100, pageNumber);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      newGradeData = data.data.map((eachGradeData) => {
        return {
          key: eachGradeData.gradeId,
          value: eachGradeData.name,
        };
      });
    }
    setNewGrade(newGradeData);
  };

  const getContent = async () => {
    setLoading(true);
    const service = await import("../../../api/contentArea.service");
    const response = service.getContentArea(pageSize, pageNumber);
    const data = (await response).data;
    setNewContent(data.data);
    let newContentData = [];
    if (data.data.length > 0) {
      newContentData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: eachContentData.name,
        };
      });
    }
    setContent(data.data);
    setNewContent(newContentData);
    setLoading(false);
  };

  useEffect(() => {
    if (isLoaded) {
      getGradeData();
      bindSubjects();
      getContent();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      getGradeData();
      bindSubjects();
      getContent();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  const filterHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    getSkillSubjectAll(
      newStateId,
      newGradeId,
      dropdownSelectedContentData,
      selectSubjectname,
      isApproved,
      isActive,
      selectSubjectId ? selectSubjectId : 0,
      sortCol,
      SortDir ? "ASC" : "DESC",
      defaultPageSize,
      defaultPageNumber
    ).then((res) => {
      const data = res.data;
      setNewBackUpSubjects(data.data);
      setNewSkills(data.data);
      setTotalPages(Math.ceil(data.totalRecords / defaultPageSize));
      setTotalRecords(data.totalRecords);
      setLoading(false);
    });
  };

  const resetClickHandler = () => {
    setLoading(true);
    setPageNumber(1);
    setdropdownSelectedContentData(0);
    setSelectSubjectname("");
    setisApproved(true);
    setIsActive(undefined);
    setSelectSkillSubjectId("");
    setNewSkills(newBackUpSubjects);
    setResetDropdownFlag(!resetDropdownFlag);
    getSkillSubjectAll(
      newStateId,
      newGradeId,
      newcontentAreaId,
      selectSubjectname,
      true,
      true,
      0,
      sortCol,
      SortDir ? "ASC" : "DESC",
      pageSize,
      pageNumber
    ).then((response) => {
      setNewSkills(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / pageSize));
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    });
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
  };

  const handleSortBy = (column: string) => {
    setSortDir(!SortDir);
    setSortCol(column);
  };

  useEffect(() => {
    if (isLoaded) {
      bindSubjects();
    }
  }, [SortDir]);

  const bindSubjects = () => {
    setLoading(true);
    getSkillSubjectAll(
      newStateId,
      newGradeId,
      newcontentAreaId,
      selectSubjectname,
      isApproved,
      isActive,
      selectSubjectId ? selectSubjectId : 0,
      sortCol,
      SortDir ? "asc" : "desc",
      pageSize,
      pageNumber
    ).then((response) => {
      setNewBackUpSubjects(response.data.data);
      setNewSkills(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / defaultPageSize));
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    });
  };

  const exportFn = async () => {
    setLoading(true);
    const module = await import("react-toastify");
    getSkillSubjectExport(
      newStateId,
      newGradeId,
      newcontentAreaId,
      selectSubjectname,
      isApproved,
      isActive,
      selectSubjectId ? selectSubjectId : 0,
      sortCol,
      SortDir ? "asc" : "desc",
      9999,
      1
    )
      .then((data) => {
        setLoading(false);
        if (data && data.data && data.data.length > 0) {
          childRef?.current?.onDownload(data.data, "practiceSubjects.csv");
        } else {
          module.toast.warning("No records to download");
        }
      })
      .catch((err) => {
        setLoading(false);
        module.toast.warning("Something went wrong!");
      });
  };

  return (
    <AllowedTo
      perform={Permissions.skill_practice_subject_view}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div id="dataContainer" className="mt-4">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-light text-gray-900">
                  Skill Practice Subject
                </h3>

                <AllowedTo perform={Permissions.skill_practice_subject_create}>
                  <button
                    type="button"
                    className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                    onClick={() => handlePostRedirect()}
                  >
                    <AddIcon className="w-6"></AddIcon>
                    Add Skill Practice Subject
                  </button>
                </AllowedTo>
              </div>
              <form action="#" onSubmit={filterHandler}>
                <div className="pt-6 border-b pb-6">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-2">
                      <label className="text-sm text-gray-700">
                        Skill Subject Id
                      </label>
                      <div className="mt-1 contentArea">
                        <input
                          id="skillSubjectId"
                          name="name"
                          type="text"
                          placeholder=""
                          className="w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          value={selectSubjectId}
                          onChange={(event: any) =>
                            setSelectSkillSubjectId(event.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-span-2">
                      <label className="text-sm text-gray-700">
                        Content Area
                      </label>
                      <div className="mt-1 text-sm">
                        <MultiSelectList
                          dropValue={newContent}
                          defaultValue={"Content Area"}
                          value={dropdownSelectedContentData}
                          resetDropdown={resetDropdownFlag}
                          dropSelect={setdropdownSelectedContentData}
                          multiple={false}
                        />
                      </div>
                    </div>
                    <div className="col-span-2">
                      <label className="text-sm text-gray-700">
                        Subject Name
                      </label>
                      <div className="contentArea">
                        <input
                          id="name"
                          name="name"
                          type="text"
                          placeholder=""
                          className=" mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          value={selectSubjectname}
                          onChange={(event: any) =>
                            setSelectSubjectname(event.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-span-2 flex items-center mt-6">
                      <MultiStateButton
                        labels={activeMultiState}
                        onSelect={(e) => setIsActive(e.value)}
                        onReset={resetDropdownFlag}
                      />
                    </div>
                    <div className="col-span-1 sm:col-span-1 flex items-end">
                      <div className="flex items-center ">
                        <input
                          id="isApproved"
                          name="isApproved"
                          type="checkbox"
                          checked={isApproved}
                          onChange={(e: any) => {
                            setisApproved(!isApproved);
                          }}
                          className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                        />
                        <label className="ml-1.5 text-sm text-gray-700">
                          Approved
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-start">
                    <button
                      type="submit"
                      className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    >
                      <FilterIcon className="w-3 h-3"></FilterIcon>
                      <span>Filter</span>
                    </button>
                    <button
                      type="button"
                      onClick={resetClickHandler}
                      className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                    >
                      <ResetIcon className="w-3 h-3"></ResetIcon>
                      <span>Reset Filter</span>
                    </button>
                  </div>
                </div>
                <div className="flex justify-end mb-2">
                  <button
                    type="button"
                    onClick={() => exportFn()}
                    className="mt-4 py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                    <span>Export</span>
                  </button>
                  <ExportToCSV ref={childRef} />
                </div>
              </form>
              <div className="flex flex-col mt-1">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-5 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Id
                                <span className="cursor-pointer">
                                  {SortDir && sortCol === "skillSubjectId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("skillSubjectId")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("skillSubjectId")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Subject
                                <span className="cursor-pointer">
                                  {SortDir && sortCol === "name" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Content Area
                                <span className="cursor-pointer">
                                  {SortDir && sortCol === "ContentArea" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("ContentArea")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("ContentArea")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="w-12 px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {newSkills.map((skills, index) => (
                            <tr
                              key={skills.skillSubjectId}
                              className={
                                index % 2 === 0 ? "bg-white" : "bg-gray-100"
                              }
                            >
                              <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500 relative">
                                {skills.isActive ? (
                                  <span className="mr-1 h-4/5 w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                ) : (
                                  <span className="mr-1 h-4/5 w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                )}
                                <Link
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  to={Constant.MANAGESKILLSUBJECT.replace(
                                    ":id",
                                    skills.skillSubjectId.toString()
                                  )}
                                >
                                  {skills.skillSubjectId}
                                </Link>
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                <Link
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  to={Constant.MANAGESKILLSUBJECT.replace(
                                    ":id",
                                    skills.skillSubjectId.toString()
                                  )}
                                >
                                  {skills.name}
                                </Link>
                              </td>
                              <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500">
                                <Link
                                  to={Constant.EDITCONTENT.replace(
                                    ":id",
                                    skills.contentAreaId.toString()
                                      ? skills.contentAreaId.toString()
                                      : ""
                                  )}
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                >
                                  {skills.contentAreaName}
                                </Link>
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                                <div className="flex gap-3 justify-center">
                                  {skills.isApproved ? (
                                    <ApproveIcon />
                                  ) : (
                                    <Disapprove />
                                  )}
                                  <AllowedTo
                                    perform={
                                      Permissions.skill_practice_subject_modify
                                    }
                                  >
                                    <EditIcon
                                      onClick={(e) => handleRedirect(skills)}
                                      className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                    />
                                  </AllowedTo>
                                  <AllowedTo
                                    perform={
                                      Permissions.skill_practice_subject_delete
                                    }
                                  >
                                    <DeleteIcon
                                      onClick={(e) =>
                                        deleteSkillHandler(
                                          e,
                                          skills.skillSubjectId
                                        )
                                      }
                                      className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                    />
                                  </AllowedTo>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  className={`flex justify-between items-center ${
                    newSkills.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />
                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                      {totalRecords} results
                    </span>

                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      ref={pageSizeRef}
                    />
                  </span>
                </div>
                {newSkills.length === 0 && ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(PracticeSubjects);
